import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BlockedCprService } from '../../services/blocked-cpr.service';

@Component({
  selector: 'app-add-blocked-cpr',
  templateUrl: './add-blocked-cpr.component.html',
  styleUrls: ['./add-blocked-cpr.component.scss']
})
export class AddBlockedCprComponent {
  cprForm: FormGroup;
  submitting = false;
  results: any = null;
  errors: string[] = [];
  success = false;

  constructor(
    private fb: FormBuilder,
    private blockedCprService: BlockedCprService,
    private router: Router
  ) {
    this.cprForm = this.fb.group({
      cprNumber: ['', [Validators.required]],
      reason: ['']
    });
  }

  onSubmit(): void {
    if (this.cprForm.invalid) {
      return;
    }

    this.submitting = true;
    this.success = false;
    this.errors = [];
    
    this.blockedCprService.addBlockedCpr(this.cprForm.value)
      .subscribe(
        response => {
          this.submitting = false;
          if (response.status) {
            this.results = response.data;
            this.errors = response.data.errors || [];
            
            // Reset form after successful submission
            if (response.data.success > 0) {
              this.success = true;
              this.cprForm.reset();
            }
          } else {
            this.errors = [response.message || 'Failed to add CPR numbers.'];
          }
        },
        error => {
          this.submitting = false;
          console.error('Error adding blocked CPR:', error);
          this.errors = [error.error?.message || 'An error occurred while adding the CPR number(s).'];
        }
      );
  }

  goBack(): void {
    this.router.navigate(['/blocked-cpr']);
  }
} 